import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import R from 'ramda';
import Heading from '@cotyorg/ccx-atoms/Heading';
import { Newsletter } from '@cotyorg/ccx-molecules/Newsletter';
import { Social } from '@cotyorg/ccx-molecules/Social';

const generateNewsletterClassNames = extraClassNames => classNames(
  'social-newsletter social-newsletter-simple',
  'text--center',
  'large-text--left',
  extraClassNames,
);

const SocialNewsletterSimple = ({
  socialNewsletterData,
  headingLevel,
  headingUnderlined,
  buttonIconSrc,
  socialIconSrc,
  buttonType = 'default',
  extraClass,
  rel,
}) => (
  <div className={generateNewsletterClassNames(extraClass)}>
    <Heading
      extraClass="social-newsletter-simple__heading"
      level={headingLevel}
      isUnderlined={headingUnderlined}
    >
      {R.path(['newsletter', 'heading'])(socialNewsletterData)}
    </Heading>

    <Newsletter
      buttonType={buttonType}
      buttonIconSrc={buttonIconSrc}
    />

    <Social
      socialIconSrc={socialIconSrc}
      rel={rel}
    />
  </div>
);

SocialNewsletterSimple.propTypes = {
  socialNewsletterData: PropTypes.shape({
    newsletter: PropTypes.shape({
      heading: PropTypes.string,
    }),
  }),
  headingLevel: PropTypes.number,
  headingUnderlined: PropTypes.bool,
  buttonIconSrc: PropTypes.string,
  buttonType: PropTypes.oneOf(['default', 'icon']),
  socialIconSrc: PropTypes.objectOf(PropTypes.string),
  extraClass: PropTypes.string,
  rel: PropTypes.string,
};

export default SocialNewsletterSimple;
